import React, { useEffect, useState } from "react";
import ApiService from "../../../Services/user/service";
import DocumentModal from "../../../components/documentModal";
import TradingViewChart from "../../../components/tradechart";
const Researchs = () => {
  const id = localStorage.getItem("parent_id");
  const currency = localStorage.getItem("currentCurrency");
  const type = currency === "1" ? "Inr" : "";
  const [researchData, setResearchData] = useState([]);
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [tradeData, setTradeData] = useState(null);
    const [kycStatus, setKycStatus] = useState(0);
      const [showKycModal, setShowKycModal] = useState(false);
  const [tradeType, setTradeType] = useState("BUY");
const [lot, setLot] = useState("");
const [qty, setQty] = useState("0.00");
const [orderType, setOrderType] = useState("Market");
      
  const getUserData = async () => {
    try {
      const userid = localStorage.getItem("user_id");
      const res = await ApiService.getUserDetail(userid);

      if (res?.data?.data?.length > 0) {
        setKycStatus(res.data.data[0].kyc);
        // 0 = not done, 1 = approved, 2 = pending (example)
      }
    } catch (error) {
    }
  };


  const fetchResearches = async () => {
    try {
      const res = await ApiService.getResearch(id, type);
      setResearchData(res?.data?.data || []);
    } catch (error) {
    }
  };

  useEffect(() => {
    getUserData();
    fetchResearches();
  }, [currency]);

    const handleTradeClick = (type, item) => {
    if (kycStatus !== 1) {
      setShowKycModal(true); 
      return;
    }

    setTradeType(type);
    setTradeData(item);  
    setShowTradeModal(true);
  };


  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <div className="card-title fw-bold fs-5">Research</div>
        </div>

        <div className="card-body">
          <div className="row g-4">

            {researchData.map((item) => (
              <div className="col-md-6" key={item._id}>
                <div className="research-card">

                  {/* Coin */}
                  <h5 className="coin">{item.coin}</h5>

                  {/* Date | Status | LTP */}
                  <div className="meta">
                    <span>
                      {new Date(item.createdAt).toLocaleDateString()}
                    </span>
                    <span className={`status ${item.status.toLowerCase()}`}>
                      {item.status}
                    </span>
                    <span>LTP: {item.price}</span>
                  </div>

                  {/* SL | Entry | Target */}
                  <div className="price-line">
                    <span>SL: {item.stopLoss}</span>
                    <span>Entry: {item.price}</span>
                    <span>Target: {item.targetPrice}</span>
                  </div>

                  {/* Buy Button */}
                  {item.type === "buy" && (
                    <button
                     onClick={() => handleTradeClick("BUY", item)}
                    className="buy-btn">BUY</button>
                  )}

                </div>
              </div>
            ))}

            {researchData.length === 0 && (
              <p className="text-center text-muted">No Research Found</p>
            )}

          </div>
        </div>
      </div>



  {showTradeModal && tradeData && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.75)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
            <div
              className="modal-content rounded-4 p-3"
              style={{
                background: "#0b1220",
                color: "#ffffff",
                border: "1px solid #1f2a44",
              }}
            >

              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="m-0 text-uppercase text-info">
                  {tradeData.exch_seg}
                </h6>
                <button
                  className="btn btn-sm text-white"
                  onClick={() => setShowTradeModal(false)}
                >
                  ✕
                </button>
              </div>


              <TradingViewChart />
              {/* SYMBOL + PRICE */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold">{tradeData.symbol}</h5>
                <h5 className="fw-bold text-info">
                  ${tradeData.liveprice}
                </h5>
              </div>

              {/* LOT SIZE + LOT */}
              <div className="row g-2">
                <div className="col-6">
                  <label className="small text-secondary">Lot Size</label>
                  <input
                    className="form-control border-0 text-white"
                    style={{ background: "#111b34" }}
                    value={tradeData.lotsize}
                    disabled
                  />
                </div>

                <div className="col-6">
                  <label className="small text-secondary">Lot</label>
                  <input
                    className="form-control text-white "
                    style={{ background: "#111b34", border: "1px solid #1f2a44" ,  }}
                    placeholder="Enter Lot"
                    value={lot}
                    onChange={(e) => {
                      const val = e.target.value;
                      setLot(val);
                      setQty(val ? Number(val).toFixed(1) : "0.00");
                    }}
                  />
                </div>
              </div>

              {/* QTY */}
              <div className="mt-3">
                <label className="small text-secondary">Buy / Sell Quantity</label>
                <input
                  className="form-control text-white border-0"
                  style={{ background: "#111b34" }}
                  value={qty}
                  disabled
                />
              </div>

              {/* ORDER TYPE */}
              <div className="d-flex gap-2 mt-3">
                {["Market", "Limit", "Stop"].map((t) => (
                  <button
                    key={t}
                    className="btn w-100"
                    onClick={() => setOrderType(t)}
                    style={{
                      background: orderType === t ? "#2563eb" : "#111b34",
                      border: "1px solid #1f2a44",
                      color: "#fff",
                      borderRadius: "20px",
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>

              {/* LIMIT */}
              {orderType === "Limit" && (
                <div className="mt-3">
                  <label className="small text-secondary">Limit Price</label>
                  <input
                    className="form-control text-white border-0"
                    style={{ background: "#111b34" }}
                    placeholder="Enter Limit Price"
                  />
                </div>
              )}

              {/* STOP */}
              {orderType === "Stop" && (
                <div className="mt-3">
                  <label className="small text-secondary">Trigger Price</label>
                  <input
                    className="form-control text-white border-0"
                    style={{ background: "#111b34" }}
                    placeholder="Enter Trigger Price"
                  />
                </div>
              )}

              {/* MARGIN */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span>With Margin</span>
                <input type="checkbox" defaultChecked />
              </div>

              {/* PRICE + BROKERAGE */}
              <div className="row g-2 mt-3">
                <div className="col-6">
                  <div className="p-2 rounded" style={{ background: "#111b34" }}>
                    <div className="small text-secondary">Price</div>
                    <div>$0</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="p-2 rounded" style={{ background: "#111b34" }}>
                    <div className="small text-secondary">Brokerage</div>
                    <div>
                      ${lot ? `${Number(lot).toFixed(1)} + ${Number(lot).toFixed(1)}` : "0.0 + 0.0"}
                    </div>
                  </div>
                </div>
              </div>

              {/* FUNDS */}
              <div className="row g-2 mt-3">
                <div className="col-6">
                  <div className="p-3 rounded" style={{ background: "#111b34" }}>
                    <div className="text-warning small">Required Funds</div>
                    <div className="fw-bold">$0</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="p-3 rounded" style={{ background: "#111b34" }}>
                    <div className="text-success small">Available Margin</div>
                    <div className="fw-bold">$1823774534.11</div>
                  </div>
                </div>
              </div>

              {/* BUY / SELL */}
              <button
                className="btn w-100 mt-4 fw-bold py-2"
                style={{
                  background: tradeType === "BUY" ? "#16a34a" : "#dc2626",
                  color: "#fff",
                  fontSize: "18px",
                  borderRadius: "12px",
                }}
              >
                {tradeType}
              </button>

            </div>
          </div>
        </div>
      )}



        {showKycModal && (
        <DocumentModal
          show={showKycModal}
          onClose={() => {
            setShowKycModal(false);
            getUserData();
          }}
        />
      )}


    </div>
  );
};

export default Researchs;
